import * as React from 'react';

function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }

  return target;
}

var IconCalendar = function IconCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _object_spread({
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 4.88916C2.25 4.47495 2.58579 4.13916 3 4.13916H29C29.4142 4.13916 29.75 4.47495 29.75 4.88916V28.0003C29.75 28.4145 29.4142 28.7503 29 28.7503H3C2.58579 28.7503 2.25 28.4145 2.25 28.0003V4.88916ZM3.75 5.63916V27.2503H28.25V5.63916H3.75Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 10.6667C2.25 10.2525 2.58579 9.91675 3 9.91675H29C29.4142 9.91675 29.75 10.2525 29.75 10.6667C29.75 11.081 29.4142 11.4167 29 11.4167H3C2.58579 11.4167 2.25 11.081 2.25 10.6667Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.77344 1.25C9.18765 1.25 9.52344 1.58579 9.52344 2V4.88889C9.52344 5.3031 9.18765 5.63889 8.77344 5.63889C8.35922 5.63889 8.02344 5.3031 8.02344 4.88889V2C8.02344 1.58579 8.35922 1.25 8.77344 1.25Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2207 1.25C23.6349 1.25 23.9707 1.58579 23.9707 2V4.88889C23.9707 5.3031 23.6349 5.63889 23.2207 5.63889C22.8065 5.63889 22.4707 5.3031 22.4707 4.88889V2C22.4707 1.58579 22.8065 1.25 23.2207 1.25Z",
    fill: "black"
  }));
};

export { IconCalendar };